import React, { PropsWithChildren, useContext, useMemo } from 'react'
import { ViewStyle } from 'react-native'
import { Element } from './Element'
import { TokensContext } from './context'
import { useBreakpoint } from './useBreakpoint'

import { selectBreakpointToken } from './util/selectBreakpointToken'

export const Grid = ({ children, gap = 8 }: PropsWithChildren<{ gap?: number }>) => {
  const tokensContext = useContext(TokensContext)

  const tokenizedGap = useMemo(() => {
    const size = tokensContext.size
    if (size === undefined) return gap
    if (typeof size === 'number') return size
    return size[gap] ?? gap
  }, [gap, tokensContext])

  return (
    <Element style={{ flexDirection: 'row', flex: 1, gap: tokenizedGap } as ViewStyle}>
      {children}
    </Element>
  )
}

export const Column = ({
  span = 1,
  children,
}: PropsWithChildren<{ span?: number | number[] }>) => {
  const breakpoint = useBreakpoint()

  const breakpointSpan = useMemo(() => {
    return selectBreakpointToken(breakpoint, span)
  }, [breakpoint, span])

  const elementStyles = useMemo(() => {
    return {
      display: 'flex' as const,
      flexDirection: 'column' as const,
      flex: breakpointSpan,
    }
  }, [breakpointSpan])

  return <Element style={elementStyles as ViewStyle}>{children}</Element>
}
